<template>
  <div>
      <list
      row-key="RecordId"
      ref="list"
      unit="案例"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
      :default-sort="{prop: 'ReleaseTime', order: 'descending'}"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="标题">
          <el-input v-model="params.InfoTitle" placeholder="请输入标题" clearable />
        </el-form-item>
        <el-form-item label="类别">
          <el-select v-model="params.InfoTypeId" placeholder="请选择类别" clearable>
            <el-option v-for="item in list" :key="item.RecordId" :value="item.RecordId" :label="item.TypeName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布日期">
          <el-date-picker
            v-model.trim="params.ReleaseTimeBegin"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.ReleaseTimeEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-select v-model="params.IfTop" placeholder="请选择" clearable>
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="OrderId" label="序号" width="60" align="center" />
        <el-table-column prop="InfoTitle" label="标题" />
        <el-table-column prop="TypeName" label="类别" />
       <el-table-column prop="InfoSource" label="信息来源" v-if="false"/>
        <el-table-column prop="ReleaseTime" align="center" label="发布时间" width="110" sortable>
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.ReleaseTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="IfTop" align="center" label="是否置顶" width="80">
          <template slot-scope="{ row }">
            <el-tag size="small" type="danger" v-if="row.IfTop==0">否</el-tag>
            <el-tag size="small" type="success" v-else>是</el-tag>
          </template>
        </el-table-column>
         <!-- <el-table-column prop="State" width="80px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.State == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/information/detail").default,
      api2: require("@/api/information/type").default,
      params: {
        InfoTitle: "",
        InfoTypeId: null,
        ReleaseTimeBegin: "",
        ReleaseTimeEnd: "",
        InfoContent: "",
        IfTop: null,
        State: null,
      },
      list: [],
    };
  },
  mounted() {
    this.api2.list({State:1}).then(res => {
      if(res.Code==0) {
        this.list = res.Data;
      }
    })
  },
  beforeMount() {
    if(this.$route.query.state) {
      this.params.State = Number(this.$route.query.state);
    }
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({Count: 0, Data: []});
      })
      // if(!params.SortName) {
      //   params.SortName = "publishTime";
      //   params.SortOrder = "desc";
      // }
      // return new Promise((resolve,reject) => {
      //   if(!(params.isShow == undefined && params.isRecommend == undefined && params.isTop == undefined)) {
      //     params.Module = 0;
      //   }
      //   this.api.list(params).then(res => {
      //     resolve(res);
      //   })
      // })
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  }
};
</script>